export default {
    methods: {
        formatPercent(value) {
          return Number(value / 100).toLocaleString('pt-BR', {style: 'percent', minimumFractionDigits: 2});
        }
    }
}